import { render, staticRenderFns } from "./NewHallContainer.vue?vue&type=template&id=064bf2c0"
import script from "./NewHallContainer.vue?vue&type=script&lang=js"
export * from "./NewHallContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports